import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function FeaturedArticles() {
  const navigate = useNavigate();

  const featured = articles.filter((a) => a.featured).slice(0, 4);

  const handleClick = (id: number) => {
    navigate(`/article/${id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            编辑团队精心挑选的深度好文，带你走进情感文学的精彩世界
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {featured.map((article) => (
            <button
              key={article.id}
              onClick={() => handleClick(article.id)}
              className="group flex flex-col sm:flex-row gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300 text-left cursor-pointer"
            >
              <div className="w-full sm:w-44 h-36 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}